<template>
	<div class="box">
		<div class="cont" v-if="xianshi == true">
			<div class="gongsi" v-for="(item, index) in list" :key="index">
				<div :class="{ bigCompany: index == 0, item_list: true,clearfix:true }">
					<img :src="item.showpath" alt="" />
					<div class="item_cont">
						<h4>{{ item.companyname }}</h4>
						<p>地址：{{ item.companyarea }}</p>
						<div v-if="index == 0">
							<div>
								<span> 电话：{{ item.cophone }}</span>
								<span> 传真：{{ item.cofaxphone }}</span>
							</div>
							<div>
								<span> 邮编：{{ item.zipcode }}</span>
								<span> 邮箱：{{ item.email }}</span>
							</div>
						</div>
						<div v-else style="display:flex;flex-direction:column">
							<div >
								<span style="flex:1"> 电话：{{ item.cophone }}</span>
								<span style="flex:1"> 邮编：{{ item.zipcode }}</span>
								
							</div>
							<div>
								<span style="flex:1"> 传真：{{ item.cofaxphone }}</span>
								<span style="flex:1"> 邮箱：{{ item.email }}</span>
							</div>
						</div>
						<p class="phone_info">联系人：{{ item.coperson }}</p>
					</div>
				</div>
				<div @click="bian(item.show,index)" v-if="item.deptlist.length != 0" style="float: left;width: 100%;border: 1px solid #e3e3e3;box-sizing: border-box;background-color: #fff;text-align: center;font-size: 24px;cursor: pointer;">
					<i v-if="item.show == false" class="el-icon-arrow-down"></i>
					<i v-if="item.show == true" class="el-icon-arrow-up"></i>
				</div>
				<el-table :header-cell-style="{background:'#409eff',color:'#fff'}" v-if="item.deptlist.length != 0 && item.show == true" :data="item.deptlist" border style="width: 100%">
					<el-table-column prop="deptname" label="部门名称" align="center" height show-overflow-tooltip>
					</el-table-column>
					<el-table-column prop="deptmaster" label="部门负责人" align="center" height show-overflow-tooltip>
					</el-table-column>
					<el-table-column prop="tel" label="联系电话" align="center" height show-overflow-tooltip>
					</el-table-column>
					<el-table-column  label="邮箱地址" align="center" height show-overflow-tooltip>
						<template slot-scope="scope">
							<span v-if="scope.row.email">{{ scope.row.email }}</span>
							<span v-else>/</span>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				xianshi:false,
				list: [],
			};
		},
		methods: {
			bian(a, b) {
				var that = this;
				that.list[b].show = !a;
				console.log(that.list[b].show);
			},
			handelToDetail(e, index) {
				this.$router.push({
					path: `/aboutus?checked=4&selected=${index}`
				});
			},
			getImgUrl(icon) {
				//展示图片
				return require(`@/assets/del/${icon}.png`);
			},
			getPhoneList() {
				var that = this;
				that.$http.get('webpc/pccompanymaillist/list', {
					params: {
						page:1,
						pagesize:50000
					}
				}, {
					emulateJSON: true
				}).then(res => {
					// console.log(result.data);
					// this.list = result.body.rows
					if(res.data.result == 200){
						that.xianshi = true;
						var list = res.data.detail.list;
						for(var i = 0;i<list.length;i++){
							list[i].show = false;
						}
						that.list = list;
						if(that.list.length > 0){
							that.list[0].show = true;
						}
						console.log(that.list);
						// console.log(this.jianjie);
					}
				})

			},
			getbumen(a) {
				var that = this;
				that.$axios({
					method: "get",
					url: "/webpc/deprt/list",
					// data: this.$qs.stringify(data)
					params: {
						companyid: that.list[a].companyuuid
					}
				}).then(res => {
					// console.log(JSON.stringify(res.data));
					// console.log(res.data.data);
					if (res.data.code == 200) {
						that.list[a].bumen = res.data.rows;
						var changdu = that.list.length - 1;
						if(a == changdu){
							that.xianshi = true;
						}
					}

				})
			}
		},
		mounted() {
			this.getPhoneList()
		}
	};
</script>

<style lang="scss" scoped>
	.box {
		width: 100%;
		height: 100%;
		overflow: hidden;
		background-color: #efefef;
		display: flex;
		justify-content: center;
	
		.cont {
			padding: 30px 0 60px 0;
			width: 1200px;
			display: flex;
			flex-direction: column;
	
			.item_list {
				width: 100%;
				margin-top: 20px;
				font-size: 20px;
				cursor: pointer;
				img {
					float: left;
					width: 228px;
					height: 186px;
				}
				.item_cont:hover{
					background-color: #fff5eb;

				}
				.item_cont {
					float: left;
					padding-left: 35px;
					box-sizing: border-box;
					background-color: #fff;
					color: #3f3f3f;
					font-size: 14px;
					height: 186px;
					width: calc(100% - 228px);
	
					h4 {
						margin-top: 18px;
						padding-bottom: 10px;
						margin-bottom: 10px;
						border-bottom: 1px solid #e55c34;
						color: #e55c34;
						font-size: 18px;
						width: 330px;
					}
	
					p {
						margin-bottom: 8px;
					}
	
					div {
						width: 100%;
						display: flex;
						flex-direction: row;
						justify-content: space-between;
						
						span {
							margin-bottom: 8px;
						}
					}
					

				}
			}
	
			.bigCompany {
				margin-top: 0px !important;
	
				img {
					width: 228px;
					height: 186px;
				}
				.item_cont:hover{
					background-color: #5474ce;
				}
				.item_cont {
					background: #5474ce;
					color: #FFF;
					height: 186px;

					h4 {
						color: #FFF;
						width: 96%;
						border-bottom: 1px solid #c4d1f4;
					}
	
					div {
						width: 100%;
						margin-bottom: 0;
	
						div {
							display: flex;
							flex-direction: column;
	
							// display: inline-block;
							span {
								flex-wrap: nowrap;
							}
						}
					}
				}
			}
		}
	}
</style>
